import { useAuth } from "../auth/AuthContext";
import PlaygroundListPage from "../playground/PlaygroundListPage";
import { StudentAppShell } from "../student/StudentAppShell";

/** Playground list with student sidebar when the viewer is a student. */
export default function PlaygroundListRoute() {
  const { profile } = useAuth();
  if (profile?.role === "student") {
    return (
      <StudentAppShell>
        <PlaygroundListPage />
      </StudentAppShell>
    );
  }
  return <PlaygroundListPage />;
}
